import React, { useState } from "react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { Divider, Typography } from "@mui/material";
import { Box } from "@mui/system";
import Field from "../Field/Fi";
import SearchIcon from "@mui/icons-material/Search";
import ListComponent from "../ListComponent";
import { CategoriesHeavyMachinery } from "../../../tempData/data";
import { ListItemButton, ListItemText } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function Categories({ open, toggleDrawer }) {
  const [categorySearch, setCategorySearch] = useState("");
  const handleCategorySearch = () => {};
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={() => toggleDrawer(false)}
      PaperProps={{
        sx: {
          minHeight: "100%",
          boxShadow:
            "0px -8px 10px rgba(0, 0, 0, 0.14), 0px -3px 14px rgba(0, 0, 0, 0.12), 0px -5px 5px rgba(0, 0, 0, 0.2)",
        },
      }}
    >
      <Box sx={{ margin: "20px 20px 36px 20px" }}>
        <ArrowBackIcon
          sx={{
            width: "24px",
            height: "24px",
            color: "#255CCE",
          }}
          onClick={() => toggleDrawer(false)}
        />
      </Box>
      <Box
        sx={{ background: "#fff", padding: "0px 20px", minHeight: "88Zzvh" }}
      >
        <Typography
          variant="h3"
          sx={{ fontSize: "22px", lineHeight: "26px", fontWeight: "600" }}
        >
          Categories
        </Typography>
        <Box sx={{ marginTop: "16px", marginBottom: "24px" }}>
          <Field
            label="Category, Make or Model"
            endIcon={
              <SearchIcon
                color="#808080"
                sx={{ width: "24px", height: "24px" }}
              />
            }
            height="46.29px"
            value={categorySearch}
            handleChange={handleCategorySearch}
          />
        </Box>
        <Box>
          <ListComponent
            text="Heavy Machinery"
            endIcon={true}
            iconColor={"#255CCE"}
          >
            {CategoriesHeavyMachinery.map((cat) => {
              return (
                <ListItemButton sx={{ padding: "0px 0px 16px" }}>
                  <ListItemText
                    primary={
                      <Typography
                        variant="body1"
                        sx={{ fontSize: "16px", lineHeight: "24px" }}
                      >
                        {cat}
                      </Typography>
                    }
                  />
                </ListItemButton>
              );
            })}
          </ListComponent>
          <Divider color="#D6D6D6" />
          <ListComponent
            text="Trucks"
            endIcon={true}
            iconColor={"#255CCE"}
          ></ListComponent>
          <Divider color="#D6D6D6" />

          <ListComponent
            text="Material Handling Equipment"
            endIcon={true}
            iconColor={"#255CCE"}
          ></ListComponent>
          <Divider color="#D6D6D6" />
        </Box>
      </Box>
    </SwipeableDrawer>
  );
}

export default Categories;
